import { MY_WALLET } from '../ids';
import { InstallLocation } from '../types';
export const ids = MY_WALLET;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Settings,
    social: false,
    showInLoginMenu: true,
    method: 'addApplication',
    urlOverride: 'my-wallet',
    uninstallable: true,
    page: {
        name: t('members-area.my-wallet.page.title'),
        shortDescription: t('members-area.my-wallet.page.subtitle'),
        description: t('members-area.my-wallet.page.description'),
        origin: t('members-area.my-wallet.author'),
        iconURL: `${staticsUrl}assets/images/icons/stores-icon.png`,
        screenshots: [
            `${staticsUrl}assets/images/my-wallet/my-wallet.png`,
            `${staticsUrl}assets/images/my-wallet/my-wallet-2.png`,
            `${staticsUrl}assets/images/my-wallet/mobile-my-wallet.png`,
            `${staticsUrl}assets/images/my-wallet/mobile-my-wallet-2.png`,
        ],
    },
});
//# sourceMappingURL=my-wallet.js.map